<div mat-dialog-content class="dialog-container">
    <div class="d-flex justify-content-between">
        <h5 class="title mb-3">Avaliação - {{title}}</h5>
        <span class="material-icons close-icon-modal" (click)="confirm()">close</span>
    </div>
    <div class="upload-container" *ngIf="!onlyView">
        <div class="col-12 p-0">
            <div *ngIf="imgUploader$ | async as uploader">
                <div class="ng2FileDrop d-flex align-items-center justify-content-between mb-1" ng2FileDrop [uploader]="uploader">
                    <div class="d-flex align-items-center gap-2">
                        <i class="material-icons upload-icon">file_upload</i>
                        <em>{{ mediaType === 'photo' ? 'Arraste e solte a imagem aqui' : 'Arraste e solte o vídeo aqui' }}</em>
                    </div>
                    <span class="btn btn-outline-light">
                        <span>SELECIONAR ARQUIVO</span>
                        <input type="file" id="reportUrl" [attr.accept]="mediaType === 'photo' ? 'image/*' : 'video/*'" ng2FileSelect [uploader]="uploader" />
                    </span>
                </div>
                <small class="max-filesize">Tamanho máximo: 20MB</small>
            </div>
            <div class="file-upload-item mb-3" *ngIf="isUploading && uploadFileName">
                <div class="file-info">
                    <span class="file-name">{{ uploadFileName }}</span>
                    <div class="file-progress-container">
                        <div class="file-progress-bar" [ngStyle]="{'width': (uploadProgress > 0 ? uploadProgress : 5) + '%'}"></div>
                    </div>
                </div>
            </div>
            <div *ngIf="imgUploadMessage && !isUploading" class="file-upload-status warning-box mt-2">
                <i class="material-icons">warning</i>
                {{ imgUploadMessage }}
            </div>
        </div>
    </div>
    @if (photosAndVideos.length > 0) {
    <div class="col-12 my-2 p-0">
        <div class="card-container">
            <div class="card" *ngFor="let media of photosAndVideos; let i = index">
                <img [src]="getMediaSrc(media.url)" class="card-image" *ngIf="!media.isVideo" (click)="openPreview(i)">
                <video [src]="getMediaSrc(media.url)" class="card-image" *ngIf="media.isVideo" controls preload="metadata" (click)="openPreview(i)"></video>
                <button type="button" class="remove-button" (click)="removeItem(media.url); $event.stopPropagation()" *ngIf="!onlyView">×</button>
            </div>
        </div>
        <ngx-gallery 
        [options]="galleryOptions"
        [images]="galleryImages"
        #onlyPreviewGallery>
      </ngx-gallery>
    </div>
    }

    <div class="col-12 p-0 mt-2" *ngIf="!isMobile && (cameraActive || isRecording) && !isUploading">
        <div class="camera-preview-wrap">
            <video #cameraPreview class="camera-preview" playsinline muted></video>
            @if (isRecording) {
                <span class="recording-badge">Gravando...</span>
            }
        </div>
    </div>
    
    <div class="col-12 p-0 mt-2 processing-overlay" *ngIf="isUploading && !uploadFileName">
        <div class="processing-box">
            <div class="processing-spinner"></div>
            <p class="processing-message">{{ imgUploadMessage || 'Processando...' }}</p>
        </div>
    </div>
    @if (cameraError) {
        <div class="col-12 p-0 mt-2 file-upload-status warning-box">
            <i class="material-icons">warning</i>
            {{ cameraError }}
        </div>
    }
    <div class="col-12 p-0 mt-3 action-buttons" *ngIf="!onlyView">
        <div class="d-flex gap-2 flex-wrap align-items-stretch">
            @if (mediaType === 'photo') {
                @if (isMobile) {
                    <button type="button" class="btn btn-capture btn-rounded text-white"
                        [disabled]="isUploading"
                        (click)="nativePhotoInput.click()">
                        <span class="material-icons">add_a_photo</span>
                        Tirar foto
                    </button>
                    <input type="file" accept="image/*" capture="environment" class="d-none"
                        #nativePhotoInput (change)="onNativeCameraFileSelected($event, false)" />
                }
                @else {
                    <button type="button" class="btn btn-capture btn-rounded text-white"
                        [disabled]="isUploading"
                        (click)="takePhoto()">
                        <span class="material-icons">add_a_photo</span>
                        {{ cameraActive ? 'Capturar' : 'Tirar foto' }}
                    </button>
                }
            }
            @else {
                @if (isMobile) {
                    <button type="button" class="btn btn-capture btn-rounded text-white"
                        [disabled]="isUploading"
                        (click)="nativeVideoInput.click()">
                        <span class="material-icons">videocam</span>
                        Gravar vídeo
                    </button>
                    <input type="file" accept="video/*" capture="environment" class="d-none"
                        #nativeVideoInput (change)="onNativeCameraFileSelected($event, true)" />
                }
                @else {
                    <button type="button" class="btn btn-capture btn-rounded text-white"
                        [disabled]="isUploading"
                        (click)="recordVideo()">
                        <span class="material-icons">videocam</span>
                        {{ isRecording ? 'Parar gravação' : 'Gravar vídeo' }}
                    </button>
                }
            }
            @if (!isRecording && !cameraActive) {
            <button type="button" class="btn btn-attach btn-rounded text-white"
                [disabled]="isUploading"
                (click)="attachFileInput.click()">
                <span class="material-icons">folder</span>
                {{ mediaType === 'photo' ? 'Anexar Imagem' : 'Anexar Vídeo' }}
            </button>
            }
            <input type="file" #attachFileInput
                [attr.accept]="mediaType === 'photo' ? 'image/*' : 'video/*'"
                class="d-none"
                (change)="onAttachFileSelected($event)" />
        </div>
    </div>
</div>